import { Layout } from "@mcleod/components/src/components/layout/Layout";
import { AutogenLayoutEDITemplateSlideout } from "./autogen/AutogenLayoutEDITemplateSlideout";
import { BlurEvent, Button, ClickEvent, SlideoutDecorator, Snackbar, Textbox } from "@mcleod/components";
import { Api, ServerError } from "@mcleod/core";
import { EdiUtility } from "./EdiUtility";

interface EDITemplateSlideoutProps {
    templateId: number;
    doAfterSlideOut?: (updates: EDITemplateUpdateProps) => void;
}

export interface EDITemplateUpdateProps {
    version: string;
    transactionSet: string;
    appReceiverId: string;
    appSenderId: string;
    receiverId: string;
    senderId: string;
    templateDescription: string;
}

export class EDITemplateSlideout extends AutogenLayoutEDITemplateSlideout {
    saveButtonClicked: boolean = false;
    static showSlideout(props: EDITemplateSlideoutProps): void {
        const layout = Layout.getLayout("lme/datafusion/EDITemplateSlideout") as EDITemplateSlideout;
        const id = props.templateId;
        const saveButton = new Button({
            id: "buttonSave",
            caption: "Save",
            backgroundColor: "primary",
            color: "primary.reverse",
            minWidth: 128,
            borderWidth: 0,
            rowBreak: false,
            onClick: async (event: ClickEvent) => {
                try {
                    layout.saveButtonClicked = true;
                    saveButton.busy = true;
                    await Api.post("lme/datafusion/save-edi-template", { updated_template: layout.mainDataSource.activeRow.getChangedData(), id: layout.mainDataSource.activeRow.get("id") });
                    saveButton.busy = false;
                    await layout.slideOut();
                } catch (error) {
                    if (error instanceof ServerError && error.messages) {
                        let string = ""
                        error.messages.forEach(message => {
                            if (typeof message === 'string') {
                                if (message.includes("Exception:")) {
                                    const exceptionIndex = message.indexOf("Exception:");
                                    const stringIndex = message.indexOf("string.", exceptionIndex);
                                    if (stringIndex !== -1) {
                                        string += message.substring(exceptionIndex + "Exception:".length, stringIndex + "string.".length).trim() + "\n";
                                        return;
                                    }
                                }
                                string += message + "\n";
                            }
                        });
                        Snackbar.showWarningSnackbar("Error saving EDI template:\n" + string);
                    } else {
                        Snackbar.showWarningSnackbar("Error saving EDI template:\n" + error);
                    }
                    saveButton.busy = false;
                }
                
            },
        });
        const decorator = new SlideoutDecorator({
            layout: layout,
            width: window.innerWidth * 0.30,
            title: "Edi Template Information Display",
            fillVerticalSpace: true,
            layoutLoadListeners: async () => {
                layout.mainDataSource.addAfterModeChangeListener(() => {
                    layout.activeRow.addAfterFieldUpdateListener((event) => {
                        saveButton.enabled = layout.activeRow.hasChanged();
                    });
                });
                await layout.mainDataSource.search({ id: id });
            },
            onClose: () => {
                decorator.slideOut();
            },
            doAfterSlideOut: (decorator) => {
                if (layout.saveButtonClicked) {
                    const updates: EDITemplateUpdateProps = {
                        version: layout.mainDataSource.activeRow.get("version"),
                        transactionSet: layout.mainDataSource.activeRow.get("transaction_set"),
                        appReceiverId: layout.mainDataSource.activeRow.get("app_receiver_id"),
                        appSenderId: layout.mainDataSource.activeRow.get("app_sender_id"),
                        receiverId: layout.mainDataSource.activeRow.get("receiver_id"),
                        senderId: layout.mainDataSource.activeRow.get("sender_id"),
                        templateDescription: layout.mainDataSource.activeRow.get("name"),
                    }
                    props.doAfterSlideOut?.(updates);
                }
            },
            addlComponents: [saveButton]
        });
    }

    private handleCharacterBlur(event: BlurEvent, fieldName: string): void {
        const textbox = event.target as Textbox;
        if (textbox.text === undefined || textbox.text.trim() === "") {
            this.mainDataSource.activeRow.set(fieldName, "");
        } else {
            const value = Number(textbox.text);
            this.mainDataSource.activeRow.set(fieldName, EdiUtility.getAsciiChar(value));
        }
    }

    onBlurElementSeparator(event: BlurEvent) {
        this.handleCharacterBlur(event, "element_char");
    }

    onBlurSubElementSeparator(event: BlurEvent) {
        this.handleCharacterBlur(event, "sub_element_char");
    }

    onBlurEndOfLine1(event: BlurEvent) {
        this.handleCharacterBlur(event, "end_of_line_1_char");
    }

    onBlurEndOfLine2(event: BlurEvent) {
        this.handleCharacterBlur(event, "end_of_line_2_char");
    }

    afterExecution() {
        if (this.mainDataSource.activeRow.getString("version") === "M2/6" || this.mainDataSource.activeRow.getString("version") === "M2/8") {
            this.textboxAppSenderCode.visible = true;
            this.textboxAppReceiverCode.visible = true;
        } else {
            this.textboxAppSenderCode.visible = false;
            this.textboxAppReceiverCode.visible = false;
        }
    }
}